/**
 * 수요예배 설교 페이지
 */

import React from 'react';
import { SermonList } from '../components/SermonList';

export const WednesdaySermon: React.FC = () => {
  return <SermonList sermonType="wednesday" title="수요예배" />;
};
